import React, { useState, useEffect } from "react";
import "./providerProfile.scss";
import UserImg from "../../assets/images/user.jpg";
import ReactDatePicker from "react-datepicker";
import StarRating from "../../components/rating/StarRating";
import "react-time-picker/dist/TimePicker.css";

import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {
  CallIcon,
  EditIcon,
  EmailIcon,
  LocationIcon,
  PasswordIcon,
  StarOutline,
  UserIcon,
  ClockIcon,
  SheildIcon,
  DollorIcon,
  ServicesIcon,
} from "../../components/Icons";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import PageHeading from "../../components/pageHeading/PageHeading";
import { Delete } from "react-iconly";
import {
  login,
  updateAvailability,
  provider_getProfile,
  fetchBankDetailsStatus,
} from "../../services/auth.service";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { setLoader } from "../../slice/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../slice/authSlice";
import { apiUrl } from "../../environment";

const ProviderProfile = () => {
  let navigate = useNavigate();
  const user = useSelector(selectUser);
  const [providerData, setProviderData] = useState({});
  // const [loading, setLoading] = useState(true);
  const [availability, setAvailability] = useState();
  const [timeData, setTimeData] = useState();
  const dispatch = useDispatch();
  //   const [availability, setAvailability] = useState(
  //     providerData.availability || false
  //   );

  //   console.log("availability-profile", availability);
  const fetchProfileData = async () => {
    try {
      await dispatch(setLoader(true));
      const response = await provider_getProfile();
      // console.log("API Response:", response);
      setProviderData(response.data); // Use response.data to access the data
      setAvailability(response?.data?.provider?.isAvailable);
      let currentDate = new Date();
      let datestart = currentDate.setHours(
        response?.data?.provider?.shiftStartTime,
        0,
        0,
        0
      );
      let dateend = currentDate.setHours(
        response?.data?.provider?.shiftEndTime,
        0,
        0,
        0
      );
      let timeObj = {
        startTime: new Date(datestart),
        endTime: new Date(dateend),
      };
      setTimeData(timeObj);
      // setLoading(false);
      await dispatch(setLoader(false));
    } catch (error) {
      console.error("Error fetching profile data:", error);
      // setLoading(false);
      await dispatch(setLoader(false));
    }
  };
  useEffect(() => {
    // Fetch provider profile data from the API

    fetchProfileData();
  }, []);

  // if (loading) {
  //   return <p>Loading...</p>;
  // }

  const handleSwitchChange = async (value) => {
    const requestBody = {
      isAvailable: value, // Toggle the current state
    };
    try {
      await dispatch(setLoader(true));
      const bankResponse = await fetchBankDetailsStatus();
      if (bankResponse?.data?.status || user?.marketingEmail !== null) {
        const response = await updateAvailability(requestBody);
        setAvailability((prevChecked) => !prevChecked);
        if (response?.data?.status === true) {
          toast.success(response.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
          fetchProfileData();
        } else {
          toast.warning(response.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      } else {
        toast.warning(bankResponse?.data?.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
      await dispatch(setLoader(false));
    } catch (error) {
      console.error("Error updating availability:", error);
      await dispatch(setLoader(false));
    }
  };

  // ******************************************************************************************************
  // const handleAvailabilityToggle = async () => {
  //     try {
  //         // Make the API call to update the availability status
  //         const response = await updateAvailability(!availability);
  //         console.log('Availability Updated:ajay', response.data);

  //         setAvailability(!availability);
  //         if (response?.data?.status === true) {
  //             console.log('ajajjjaja');
  //             toast.success(response.data.message, {
  //               position: toast.POSITION.TOP_CENTER,
  //             });

  //           } else {
  //             console.log('ajajjjaja else');
  //             toast.warning(response.data.message, {
  //               position: toast.POSITION.TOP_CENTER,
  //             });

  //           }

  //     } catch (error) {
  //         console.error('Error updating availability:', error);
  //     }
  // };

  // ******************************************************************************************************

  return (
    <>
      <Header />
      <PageHeading title="Profile" />

      <div className="main-container">
        <div className="container-wrap">
          <div className="provider-setting-wrap">
            <div className="box-wrapper">
              <div className="provider-wrapper">
                <div className="provider-info-wrap">
                  <div className="provider-info-title">
                    Account setting
                    <div className="availability-row">
                      <div className="availability">
                        <i>
                          <UserIcon />
                        </i>{" "}
                        <span>Availability</span>
                      </div>
                      <Form.Check // prettier-ignore
                        type="switch"
                        id="custom-switch"
                        checked={availability}
                        onChange={(e) => {
                          handleSwitchChange(e.target.checked);
                        }}
                      />
                    </div>
                  </div>
                  <div className="user-provider-detail-top">
                    <div className="user-img-wrap">
                      <div className="user-pic">
                        {/* <img src={providerData.profilePic ? providerData.baseUrl + providerData.profilePic : UserImg} alt="User" /> */}
                        <img
                          src={
                            providerData?.provider?.profilePic
                              ? `${providerData?.baseUrl}${providerData?.provider?.profilePic}`
                              : UserImg
                          }
                          alt="User"
                        />
                      </div>
                      <div className="edit-pic">
                        <EditIcon />
                      </div>
                    </div>
                    <div className="user-name-wrap">
                      <div className="username">
                        {providerData?.provider?.firstName}{" "}
                        {providerData?.provider?.lastName}
                      </div>
                      <div className="user-rating-wrap">
                        <div className="rating">
                          <StarRating
                            value={
                              providerData?.ratingProvider
                                ? providerData?.ratingProvider
                                : 0
                            }
                          />
                        </div>
                        <div className="view-rating">
                          ({providerData?.provider?.userNumberOfRatings}) -{" "}
                          <span
                            onClick={() => navigate("/provider/viewrating")}
                          >
                            View Ratings
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="edit-btn-wrap">
                      <Button
                        variant="outline-primary"
                        onClick={() => navigate("/provider/update")}
                      >
                        Edit Profile
                      </Button>
                      {/* <Button variant="outline-primary">
                        Edit Profile
                      </Button> */}
                    </div>
                  </div>
                  <Form>
                    <Row>
                      <Col lg={6}>
                        <div className="input-wrap">
                          <div className="icon-wrap">
                            <UserIcon />
                          </div>
                          <Form.Group className="mb-4" controlId="email">
                            <Form.Label>Full Name</Form.Label>
                            <Form.Control
                              type="email"
                              placeholder="Full Name"
                              disabled
                              value={`${providerData?.provider?.firstName} ${providerData?.provider?.lastName}`}
                            />
                          </Form.Group>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="input-wrap">
                          <div className="icon-wrap">
                            <EmailIcon />
                          </div>
                          <Form.Group className="mb-4" controlId="email">
                            <Form.Label>Email address</Form.Label>
                            <Form.Control
                              type="email"
                              placeholder="Email address"
                              disabled
                              value={providerData?.provider?.email}
                            />
                          </Form.Group>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="input-wrap">
                          <div className="icon-wrap">
                            <CallIcon />
                          </div>
                          <Form.Group className="mb-4" controlId="phone">
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Phone Number"
                              disabled
                              value={providerData?.provider?.phone}
                            />
                          </Form.Group>
                        </div>
                      </Col>
                      {/* <Col lg={6}>
                        <Row>
                          <Col sm={6}>
                            <div className="input-wrap">
                              <div className="icon-wrap">
                                <ClockIcon />
                              </div>
                              <Form.Group
                                className="mb-4"
                                controlId="startTime"
                              >
                                <Form.Label>Start Time</Form.Label>
                                <ReactDatePicker
                                  className="form-control"
                                  selected={timeData?.startTime}
                                  showTimeSelect
                                  showTimeSelectOnly
                                  timeIntervals={15}
                                  dateFormat="h:mm aa"
                                  timeCaption="Time"
                                  disabled
                                />
                              </Form.Group>
                            </div>
                          </Col>
                          <Col sm={6}>
                            <div className="input-wrap">
                              <div className="icon-wrap">
                                <ClockIcon />
                              </div>
                              <Form.Group className="mb-4" controlId="endTime">
                                <Form.Label>End Time</Form.Label>
                                <ReactDatePicker
                                  className="form-control"
                                  selected={timeData?.endTime}
                                  showTimeSelect
                                  showTimeSelectOnly
                                  timeIntervals={15}
                                  dateFormat="h:mm aa"
                                  timeCaption="Time"
                                  disabled
                                />
                              </Form.Group>
                            </div>
                          </Col>
                        </Row>
                      </Col> */}
                      {/* <Col lg={6}>
                        <div className="input-wrap">
                          <div className="icon-wrap">
                            <ClockIcon />
                          </div>
                          <Form.Group className="mb-4" controlId="shiftTime">
                            <Form.Label>Shift Timing</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Shift Timing"
                              disabled
                              value="-- : --"
                            />
                          </Form.Group>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="input-wrap canclelation">
                          <div className="review">Review</div>
                          <div className="icon-wrap">
                            <SheildIcon />
                          </div>
                          <Form.Group className="mb-4" controlId="location">
                            <Form.Control
                              type="text"
                              placeholder="Cancelation Policy"
                              disabled
                              value="Cancelation Policy"
                            />
                          </Form.Group>
                        </div>
                      </Col> */}

                      <Col md={12}>
                        <div className="input-wrap">
                          <div className="icon-wrap">
                            <LocationIcon />
                          </div>
                          <Form.Group className="mb-4" controlId="bio">
                            <Form.Label>Bio</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              disabled
                              value={
                                providerData?.provider?.bio
                                  ? providerData?.provider?.bio
                                  : ""
                              }
                            />
                          </Form.Group>
                        </div>
                      </Col>

                      <Col md={12}>
                        <div className="input-wrap">
                          <div className="icon-wrap">
                            <LocationIcon />
                          </div>
                          <Form.Group className="mb-4" controlId="location">
                            <Form.Label>Location</Form.Label>
                            <Form.Control
                              type="text"
                              disabled
                              value={
                                providerData?.provider?.location
                                  ? providerData?.provider?.location
                                  : ""
                              }
                            />
                          </Form.Group>
                        </div>
                      </Col>
                      <Col md={12}>
                        {providerData?.services?.map((service, index) => (
                          <div className="add-service-container" key={index}>
                            <div className="add-row-wrap">
                              <div className="add-content">
                                <Row>
                                  <Col sm={6}>
                                    <div className="input-wrap">
                                      <div className="icon-wrap">
                                        <ServicesIcon />
                                      </div>
                                      <Form.Group
                                        controlId="addService"
                                        className="mb-3"
                                      >
                                        <Form.Label>Add Service</Form.Label>
                                        <Form.Control
                                          type="text"
                                          placeholder="Add Service"
                                          disabled
                                          value={service?.serviceId?.name}
                                        />
                                      </Form.Group>
                                    </div>
                                  </Col>
                                  <Col sm={6}>
                                    <div className="input-wrap">
                                      <div className="icon-wrap">
                                        <DollorIcon />
                                      </div>
                                      <Form.Group
                                        controlId="hourlyRate"
                                        className="mb-3"
                                      >
                                        <Form.Label>
                                          Setup the hourly rate
                                        </Form.Label>
                                        <Form.Control
                                          type="text"
                                          disabled
                                          placeholder="Setup the hourly rate"
                                          value={service?.rate}
                                        />
                                      </Form.Group>
                                    </div>
                                  </Col>
                                </Row>
                                <div className="service-images">
                                  <div className="uploaded-images">
                                    {service.images.map((image, imgIndex) => (
                                      <div
                                        key={imgIndex}
                                        className="image-container"
                                      >
                                        <img
                                          src={`${apiUrl}/${image}`}
                                          alt={`Service ${index + 1} Image ${
                                            imgIndex + 1
                                          }`}
                                          className="service-image"
                                          style={{
                                            maxWidth: "100px",
                                            maxHeight: "100px",
                                          }}
                                        />
                                      </div>
                                    ))}
                                    {/* <br/> */}
                                  </div>
                                </div>
                              </div>
                              {/* <div className="delete-icon">
                              <Delete />
                            </div> */}
                            </div>
                          </div>
                        ))}
                        <br />
                      </Col>
                      {/* <Col md={12} className="mb-4 mt-2">
                        <span className="add-service-link">
                          + Add more services
                        </span>
                      </Col> */}
                      <Col md={12}>
                        <div className="input-wrap">
                          <div className="icon-wrap">
                            <SheildIcon />
                          </div>
                          <Form.Group className="mb-2" controlId="policy">
                            <Form.Label>Cancelation Policy</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              disabled
                              value={
                                providerData?.policyText
                                  ? providerData?.policyText
                                  : "Not Available"
                              }
                            />
                          </Form.Group>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </div>

                <div className="provider-info-wrap">
                  <div className="provider-info-title">Password</div>
                  <Row>
                    <Col md={12}>
                      <div className="input-wrap">
                        <div className="icon-wrap">
                          <PasswordIcon />
                        </div>
                        <Form.Group className="mb-2" controlId="Password">
                          <Form.Label>Password</Form.Label>
                          <Form.Control
                            type="Password"
                            placeholder="Change Password"
                            disabled
                          />
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ProviderProfile;
